import Vue from 'vue'
import sensorservice from '../service/sensor'
const state = {
    loading: false,
    duckSensors: []
}

const actions = {
    getSensors({ commit }) {
        commit('setLoading', true)
        return sensorservice.getSensors().then((sensors) => {
            commit('setSensors', sensors)
        }).finally(() => {
            commit('setLoading', false)
        })
    }
}

const mutations = {
    setLoading(state, bool) {
        state.loading = bool;
    },
    setSensors(state, sensors) {
        state.duckSensors = sensors;
        state.loading = false
    }
}

export default {
    namespaced: true,
    state,
    actions,
    mutations
};
